import * as yup from 'yup';
export const CATEGORIES = [
    {
        label: 'Arts',
        subcategories: [
            'Books',
            'Design',
            'Fashion & Beauty',
            'Food',
            'Performing Arts',
            'Visual Arts',
        ],
    },
    {
        label: 'Business',
        subcategories: [
            'Careers',
            'Entrepreneurship',
            'Investing',
            'Management',
            'Marketing',
            'Non-Profit',
        ],
    },
    {
        label: 'Comedy',
        subcategories: ['Comedy Interviews', 'Improv', 'Stand-Up'],
    },
    {
        label: 'Education',
        subcategories: ['Courses', 'How To', 'Language Learning', 'Self-Improvement'],
    },
    {
        label: 'Fiction',
        subcategories: ['Comedy Fiction', 'Drama', 'Science Fiction'],
    },
    {
        label: 'Government',
    },
    {
        label: 'History',
    },
    {
        label: 'Health & Fitness',
        subcategories: [
            'Alternative Health',
            'Fitness',
            'Medicine',
            'Mental Health',
            'Nutrition',
            'Sexuality',
        ],
    },
    {
        label: 'Kids & Family',
        subcategories: ['Education for Kids', 'Parenting', 'Pets & Animals', 'Stories for Kids'],
    },
    {
        label: 'Leisure',
        subcategories: [
            'Animation & Manga',
            'Automotive',
            'Aviation',
            'Crafts',
            'Games',
            'Hobbies',
            'Home & Garden',
            'Video Games',
        ],
    },
    {
        label: 'Music',
        subcategories: ['Music Commentary', 'Music History', 'Music Interviews'],
    },
    {
        label: 'News',
        subcategories: [
            'Business News',
            'Daily News',
            'Entertainment News',
            'News Commentary',
            'Politics',
            'Sports News',
            'Tech News',
        ],
    },
    {
        label: 'Religion & Spirituality',
        subcategories: [
            'Buddhism',
            'Christianity',
            'Hinduism',
            'Islam',
            'Judaism',
            'Religion',
            'Spirituality',
        ],
    },
    {
        label: 'Science',
        subcategories: [
            'Astronomy',
            'Chemistry',
            'Earth Sciences',
            'Life Sciences',
            'Mathematics',
            'Natural Sciences',
            'Nature',
            'Physics',
            'Social Sciences',
        ],
    },
    {
        label: 'Society & Culture',
        subcategories: [
            'Documentary',
            'Personal Journals',
            'Philosophy',
            'Places & Travel',
            'Relationships',
        ],
    },
    {
        label: 'Sports',
        subcategories: [
            'Baseball',
            'Basketball',
            'Cricket',
            'Fantasy Sports',
            'Football',
            'Golf',
            'Hockey',
            'Rugby',
            'Running',
            'Soccer',
            'Swimming',
            'Tennis',
            'Volleyball',
            'Wilderness',
            'Wrestling',
        ],
    },
    {
        label: 'Technology',
    },
    {
        label: 'True Crime',
    },
    {
        label: 'TV & Film',
        subcategories: [
            'After Shows',
            'Film History',
            'Film Interviews',
            'Film Reviews  ',
            'TV Reviews',
        ],
    },
];
export const validationSchema = yup.object().shape({
    withTags: yup.boolean().required(),
    tags: yup
        .array()
        .required()
        .when('withTags', {
        is: true,
        then: yup.array().required().min(1, 'At least one tag is required.'),
    }),
});
